import api from './api';

export interface TenantSettingsCategory {
  settings: Record<string, any>;
  overrides: string[];
}

export type TenantSettingsAll = Record<string, TenantSettingsCategory>;

const tenantSettingsService = {
  /** Get all overridable categories merged with system defaults */
  getAll: async (tenantId: string) => {
    const response = await api.get(`/tenant-settings/${tenantId}`);
    return response.data as TenantSettingsAll;
  },

  /** Get single category merged with system defaults */
  getCategory: async (tenantId: string, category: string) => {
    const response = await api.get(`/tenant-settings/${tenantId}/${category}`);
    return response.data as TenantSettingsCategory;
  },

  /** Update settings for a category */
  updateCategory: async (tenantId: string, category: string, settings: Record<string, any>) => {
    const response = await api.put(`/tenant-settings/${tenantId}/${category}`, settings);
    return response.data as TenantSettingsCategory;
  },

  /** Remove a single setting override */
  deleteSetting: async (tenantId: string, category: string, key: string) => {
    await api.delete(`/tenant-settings/${tenantId}/${category}/${key}`);
  },

  /** Reset entire category to system defaults */
  resetCategory: async (tenantId: string, category: string) => {
    await api.delete(`/tenant-settings/${tenantId}/${category}`);
  },
};

export default tenantSettingsService;
